<template>
	<div class="top_mainbox">
		<div class="login-container">
			<div class="wrapper">
				<!--user-info 右侧用户信息-->
				<Notice />
				<div class="user-info">
					<div class="login-before" v-if="!$store.state.loginStatus">
						<button class="login-button" @click="loginButton">登录</button>
						<button class="login-button" @click="registerButton">注册</button>
						<button @click="shiwan" class="login-button play-demo">试玩一下</button>
					</div>
					<div class="login-after" v-if="$store.state.loginStatus">
						<div class="btn-group">
							<div class="account-info">
								<!-- <span class="label"><img src="@/static/img/head/member.png" alt="member" />帐号</span> -->
								<span style="justify-content: center" class="label">帐号:</span>
								<span class="content">{{ userInfo.LoginName }}</span>
							</div>
							<div class="balance-info">
								<!-- <span class="label"><img src="@/static/img/head/balance-sign.png" alt="member" />余额</span> -->
								<span style="justify-content: center" class="label">余额:</span>
								<span class="content">{{ showBalance ? parseFloat(userInfo.Balance).toFixed(3) : "********" }}</span>
							</div>
							<div class="icon">
								<img
									:src="require(`@/static/img/head/display_${showBalance ? 'on' : 'off'}.png`)"
									@click="showBalance = !showBalance"
									width="21"
								/>
								<img
									src="@/static/img/icon/reset.png"
									:class="{ refresh_anima: Refresh }"
									@click="refresh"
									height="12"
								/>
							</div>
							<button @click="toCenter('zhcz', 'zhcz')">充值</button>
							<button @click="toCenter('yetx', 'yetx')">提现</button>
							<button @click="toCenter('zjzh', 'zjzh')">转帐</button>
							<el-popover
								popper-class="custom-popover"
								:visible-arrow="false"
								:popper-options="{
									boundariesElement: 'viewport',
									removeOnDestroy: true,
								}"
								placement="bottom"
								width="400"
								trigger="hover"
							>
								<div class="login-time">
									上次登录时间<span>: {{ userInfo.LastLoginTime }}</span>
								</div>
								<div class="divider"></div>
								<div class="info-wrap">
									<div class="username">
										<div class="username__label">帐号</div>
										<div class="username__divider"></div>
										<div class="username__value">{{ userInfo.LoginName }}</div>
									</div>
									<div class="logout" @click="exit">
										<img src="../../static/img/icon_power.png" />
										<div>退出登录</div>
									</div>
								</div>
								<div class="menu-wrap">
									<div class="menu-item" v-for="item in menuGroup" :key="item.title">
										<div class="title">{{ item.title }}</div>
										<div class="subtitle" v-for="(child, index) in item.children" :key="index">
											<template v-if="child[0] === '极速到账'">
												<div
													v-if="$store.state.quickWithdrawalState"
													class="subtitle__item"
													@click="toCenter(child[1], child[1])"
												>
													{{ child[0] }}
												</div>
											</template>
											<div v-else class="subtitle__item" @click="toCenter(child[1], child[1])">{{ child[0] }}</div>
										</div>
									</div>
								</div>
								<button @click="toCenter('grsy', 'grsy')" slot="reference">管理中心</button>
							</el-popover>
							<button v-if="userInfo.UtId === 1">
								<a :href="DlCenterUrl" target="_blank">代理中心</a>
							</button>
						</div>
					</div>
				</div>
			</div>

			<!--显示导航栏-->
			<hintCom ref="exitHintCom" :confirm="exitConfirm">
				<template slot="content">
					<span>是否退出登录?</span>
				</template>
			</hintCom>
			<!--登录弹窗 -->
			<transition name="login-dialog ">
				<div class="mask login" v-show="$store.state.loginAfter">
					<div class="login_div">
						<div>
							<div class="close_login" @click="$store.commit('setLoginAfter', false)" style="top: 13px">
								<span></span>
							</div>
							<loginItem ref="loginFun" />
						</div>
					</div>
				</div>
			</transition>
		</div>
		<!-- 导航栏 -->
		<div class="nav_box">
			<div class="nav-wrapper">
				<!--logo 左侧logo-->
				<router-link to="/home" class="logo box_h">
					<img src="@/static/img/head/logo.png" alt="logo" width="148" height="48" />
				</router-link>
				<ul class="nav-content">
					<li class="nav-item">
						<router-link to="/home">
							<div class="navName">首页</div>
						</router-link>
					</li>
					<li
						v-for="(apiType, index) of apiTypeMap"
						:key="index"
						:class="`nav-item dropdown`"
						@mouseenter="pullDownState = apiType.id"
						@mouseleave="navlotteryHide"
						@click="changePage"
					>
						<router-link :to="apiType.link" :class="`${pullDownState === apiType.id ? 'hover' : ''}`">
							<div class="navName">{{ apiType.name }}<i class="el-icon-arrow-down"></i></div>
						</router-link>
						<div class="dropdown-menu">
							<!--下拉二级菜单-->
							<el-collapse-transition>
								<div v-show="pullDownState === apiType.id">
									<!--常规二级菜单-->
									<ul v-if="apiType.id !== 1" :class="['third-game', { gapChanged: apiType.api.length > 4 }]">
										<li v-for="(api, index) of apiType.api" :key="index">
											<img :src="require(`@/static/img/head/${api.img}.png`)" alt="peopleGame" />
											<h5>{{ api.name }}</h5>
											<button class="startGame" @click="apiType.id === 4 ? toDzGame(api.game) : toGame(api)">
												开始游戏
											</button>
											<button class="transfer" @click="toCenter('zjzh', 'zjzh')">转帐</button>
										</li>
									</ul>
									<!--彩票二级菜单-->
									<ul v-if="apiType.id === 1" class="third-game lottery">
										<li class="lottery-list" v-for="(item, index) in $store.state.navAry" :key="index">
											<img class="icon" :src="`${url}/${item.WebIco}`" />
											<ul>
												<li v-for="value in item.LotteryList" :key="value.LgId">
													<button @click="toGame(value)">
														<img
															src="@/static/img/head/hotGame.png"
															alt="hotGame"
															class="hotGame"
															v-if="value.IsHot"
														/>{{ value.Name }}
													</button>
												</li>
											</ul>
										</li>
									</ul>
								</div>
							</el-collapse-transition>
						</div>
					</li>

					<li class="nav-item">
						<router-link to="/preMain">
							<div class="navName">优惠活动</div>
						</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/Client">
							<div class="navName">下载</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
		<cardDom @hiddenDiv="hideCardDiv" v-show="isShow" :ary="ary" :selectNav="selectTabs"></cardDom>
		<!-- 右侧悬浮 -->
		<div class="float-right">
			<ul>
				<li class="right-service">
					<a :href="kfUrl" target="_blank">
						<div class="right-text">在线客服</div>
						<div class="right-icon"><img src="../../static/img/head/float-service.png" alt="" /></div>
					</a>
				</li>
				<!-- <li class="right-service">
					<router-link to="/Client">
						<div class="right-text">APP下载</div>
						<div class="right-icon"><img src="../../static/img/head/float-phone.png" alt="" /></div>
					</router-link>
				</li> -->
				<!-- <li class="right-service">
					<router-link to="/line">
						<div class="right-text">线路检测</div>
						<div class="right-icon"><img src="../../static/img/head/float-line.png" alt="" /></div>
					</router-link>
				</li> -->
				<li class="right-service">
					<a href="javascript:" @click="onclickGonggao(ary[1].name)">
						<div class="right-text">公告</div>
						<div class="right-icon"><img src="../../static/img/head/float-notice.png" alt="" /></div>
					</a>
				</li>
				<li class="right-service">
					<router-link to="/help">
						<div class="right-text">帮助中心</div>
						<div class="right-icon"><img src="../../static/img/head/float-help.png" alt="" /></div>
					</router-link>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import hintCom from "@/components/Elasticframe/OrderCancel.vue";
import Notice from "@/components/common/notice.vue";
import cardDom from "@/components/Elasticframe/noticeCard.vue";
import { postAjax, getAjax } from "../../util/ajax.js";
import { getUserInfo, userOut, getHeadNav } from "../../util/getdata";
import { timeFormatProcessing } from "../../util/common";
import { game } from "../../mixins/game";
import loginItem from "../login/login_item";
import { Message } from "element-ui";
import { SysKey } from "@/util/sysconfig";

export default {
	mixins: [game],
	components: { hintCom, loginItem, cardDom, Notice },
	// 刷新页面
	inject: ["reload"],
	data() {
		return {
			ary: [], //传入公告栏的值
			isShow: false, //最新公告弹框状态
			selectTabs: "", //默认选中的公告
			kfUrl: SysKey("KfCenterUrl").SysValue,
			DlCenterUrl: "#",
			Refresh: false, //是否刷新余额
			hoverState: false, //下拉框是否显示
			pullDownState: 0, //显示相对应得导航下拉
			showBalance: true, // 显示与隐藏用户资金
			url: SysKey("ImgServerUrl").SysValue, //图片地址
			currentLotteryGroup: {
				NvgName: "",
				LotteryList: [],
			},
			menuGroup: [
				{
					title: "订单报表",
					children: [
						["统计报表", "tjbb"],
						["投注记录", "tzjl"],
						["追号记录", "zhjl"],
						["账变明细", "zbmx"],
						["积分明细", "jfmx"],
						["活动报表", "hdbb"],
						["三方记录", "sfjl"],
					],
				},
				{
					title: "财务中心",
					children: [
						["账户充值", "zhcz"],
						["余额提现", "yetx"],
						["资金转换", "zjzh"],
						["充值记录", "czjl"],
						["提现记录", "txjl"],
						["转帐记录", "zzjl"],
						["极速到账", "Quick"],
					],
				},
				{
					title: "个人中心",
					children: [
						["个人首页", "grsy"],
						["银行卡管理", "yhkgl"],
						["虚拟/数字钱包", "crypto"],
						["个人资料", "grzl"],
						["登录记录", "dljl"],
					],
				},
				{
					title: "消息中心",
					children: [
						["收件箱", "sjx"],
						["发件箱", "fjx"],
						["发消息", "fxx"],
					],
				},
			],
		};
	},
	computed: {
		apiTypeMap() {
			let data;
			let temp;
			data = this.$store.state.apiTypeMap; // 所有三方API信息

			console.warn(data);
			return data;
		},
		userInfo() {
			return this.$store.state.userInfo; //用户信息
		},
		getChatRoomLink() {
			if (this.userInfo.UtId == 1) {
				this.$store.dispatch("getChatRoomLink");
				return this.$store.state.chatRoomLink;
			}
		},
	},
	methods: {
		hideCardDiv() {
			this.isShow = false;
			// 关闭公告弹窗,顺便修改全局状态
			if (localStorage.getItem("alertState") !== "false") {
				this.$store.commit("CHANGEALERTSTATE");
				localStorage.setItem("alertState", "false");
			}
		},
		getNotice() {
			let url = "api/Sys/GetSysNotice";
			getAjax(url, 1)
				.then(data => {
					this.title = data.Data[0].Title;
					if (data.IsSucess) {
						this.ary = data.Data.map((item, index) => {
							return Object.assign(
								{
									name: "a" + index,
								},
								item
							);
						});
						this.ary.forEach((item, index) => {
							// 公告接口返回列表中 如果有紧急公告则需要自动弹出显示
							if (item.IsUrgent && localStorage.getItem("alertState") !== "false") {
								this.isShow = true;
								this.selectTabs = item.name;
								return false;
							}
						});
					}
				})
				.catch(err => {
					console.log("error", err);
				});
		},
		onclickGonggao(num) {
			this.selectTabs = num;
			this.isShow = true;
		},
		handleLotteryGroupHover(item) {
			this.currentLotteryGroup = item;
		},
		//最后一次登陆信息
		lastLoginInfo() {
			let url = "Api/User/UserLoginLogInfo";
			let cxData = {
				StartTime: timeFormatProcessing(),
				EndTime: timeFormatProcessing(0, 1),
				PIndex: 1,
				PSize: 2,
			};
			postAjax(url, cxData)
				.then(data => {
					if (data.IsSucess) {
						this.$store.commit("setLastLogin", data.Data.rows[1].LoginTime);
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		//跳转到电子游艺内页,并选中对应的API
		toDzGame(game) {
			this.$router.push({
				path: "/ptGame",
				query: { game },
			});
		},
		loginButton() {
			this.$store.commit("setLoginAfter", { state: "login", boll: true });
		},
		registerButton() {
			this.$store.commit("setLoginAfter", { state: "register", boll: true });
		},
		exitConfirm() {
			userOut(this.$route.path);
		},
		// 退出
		exit() {
			this.$refs.exitHintCom.show();
		},
		// 刷新
		refresh() {
			if (!this.Refresh) {
				this.Refresh = true;
				getUserInfo();
				setTimeout(() => {
					this.Refresh = false;
				}, 1500);
			}
		},
		// 请求用户数据
		userinfoAjax() {
			if (this.userInfo.UtId == 1 && location.hostname != "localhost") {
				this.DlCenterUrl =
					document.location.protocol +
					"//daili." +
					document.location.host.split(".").slice(-2).join(".") +
					"/" +
					"?token=" +
					localStorage.getItem("Authorization").replace("Basic ", "");
			}
		},
		//导航栏路由跳转-改变页面的时候,二级菜单先收起来
		changePage() {
			this.pullDownState = 0;
			this.hoverState = false;
			this.reload();
		},
		//个人中心页面
		toCenter(name, value) {
			const { path, query } = this.$route;
			if (path === "/UserCenter" && query.name === name && query.value === value) return;
			this.$router.push({
				path: "/UserCenter",
				query: {
					name: name,
					value: value,
				},
			});
		},
		notQequestData() {
			return this.$router.currentRoute.path != "/userRegister" && this.$router.currentRoute.path != "/userLogin";
		},
		// 隐藏下拉
		navlotteryHide() {
			this.hoverState = false;
			this.pullDownState = 0;
		},
		_initOpenLoading() {
			this.loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
		},
		_initCloseLoading() {
			this.loading.close();
		},
		//
		shiwan() {
			this._initOpenLoading();
			postAjax("/api/User/GetTmepUser").then(data => {
				this._initCloseLoading();
				if (data.IsSucess) {
					localStorage.setItem("Authorization", "Basic" + " " + data.Data.Token);
					localStorage.setItem("shiwan", true);
					getUserInfo();
					this.$message.success("登录成功，跳转首页中...");
					setTimeout(() => {
						this.$router.push("/home");
					}, 1000);
				} else {
					Message.error(data.Message);
				}
			});
		},
	},
	created() {
		getHeadNav();
		window.eventBus.$on("refreshHeader", () => {
			this.refresh();
		});
		if (this.notQequestData()) {
			this.userinfoAjax();
			this.getNotice();
		}
		if (localStorage.getItem("Authorization")) {
			this.lastLoginInfo();
			getUserInfo();
		}
	},
	watch: {
		userInfo: function () {
			this.userinfoAjax();
		},
		loginAfter() {
			if (this.loginAfter) {
				this.$refs.loginFun.indentyajax();
			}
		},
		pullDownState() {
			if (this.pullDownState === 1) {
				this.currentLotteryGroup = this.$store.state.navAry[0];
			}
		},
	},
};
</script>

<style scoped lang="scss">
.nav_box {
	background-color: #f9f8f8;
}

.top_mainbox {
	position: sticky;
	top: 0;
	z-index: 2000;
	background-color: #fff;
	box-shadow: 0px -4px 7px 0 rgba(0, 0, 0, 0.05), 0px 4px 7px 0 rgba(0, 0, 0, 0.05);
}

.nav_box .nav-wrapper {
	display: flex;
	align-items: center;
	max-width: 1160px;
	margin: 0 auto;
	position: relative;
}

/*一级导航下的下拉菜单*/
.nav-content {
	display: flex;
	margin-left: 43px;
	min-width: 600px;

	.nav-item:nth-child(1) {
		order: 1;
	}

	.nav-item:nth-child(2) {
		order: 2;
	}

	.nav-item:nth-child(3) {
		order: 3;
	}

	.nav-item:nth-child(4) {
		order: 6;
	}

	.nav-item:nth-child(5) {
		order: 5;
	}

	.nav-item:nth-child(6) {
		order: 4;
	}

	.nav-item:nth-child(7) {
		order: 7;
	}

	.nav-item:nth-child(8) {
		order: 8;
	}

	.nav-item:nth-child(9) {
		order: 9;
	}

	.nav-item:nth-child(10) {
		order: 10;
	}

	.nav-item {
		> a {
			display: block;
			height: 70px;
			line-height: 70px;
			padding: 0 10px;
			font-size: 14px;
			color: #555;

			i {
				color: #aaa;
				font-size: 10px;
			}
		}

		&:hover {
			color: #2794e7;

			> a {
				display: block;
				height: 70px;
				line-height: 70px;
				padding: 0 10px;
				font-size: 14px;
				color: #2794e7;

				i {
					color: #2794e7;
					font-size: 10px;
				}
			}
		}
	}

	.dropdown {
		.dropdown-menu {
			width: 100%;
			position: absolute;
			top: 70px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 2000;
		}

		.third-game {
			text-align: center;
			width: 100%;
			background-image: linear-gradient(to top, rgba(58, 150, 222, 0.8), rgba(9, 96, 164, 0.8));
			padding: 24px 179px 15px 178px;
			border-radius: 0 0 20px 20px;
			display: flex;
			align-items: flex-end;
			justify-content: center;
			gap: 50px 40px;

			&.gapChanged {
				padding: 26px 30px 15px 33px;
				gap: 50px 10px;
			}

			li {
				width: 180px;

				img {
					width: 100%;
					max-width: 100%;
				}

				h5 {
					font-size: 16px;
					font-family: PingFangSC;
					font-weight: 400;
					color: #fff;
					text-align: center;
					margin: 9px 0;
				}

				button {
					border: none;
					height: 30px;
					font-family: PingFangSC;
					font-size: 13px;
					text-align: center;
					color: #555;
					cursor: pointer;

					&:hover {
						background-image: unset;
						background-color: #6455fe;
						color: #fff;
					}
				}

				.startGame {
					width: 90px;
					// background-image: url("~@/static/img/head/left-bar-bg.png");
					background-color: #fff;
					background-size: cover;
					border-radius: 3px 0 0 3px;
				}

				.transfer {
					margin-left: -3px;
					width: 76px;
					background-color: #fff;
					// background-image: url("~@/static/img/head/right-bar-bg.png");
					background-size: cover;
					border-radius: 0px 3px 3px 0px;
				}
			}

			&.lottery {
				padding: 19px 54px 21px 46px;
				gap: 0 10px;
				align-items: flex-start;
				white-space: nowrap;

				.lottery-list {
					width: 150px;

					li {
						width: 100%;
					}

					img {
						width: 100px;
						max-width: 100%;
					}

					ul {
						display: flex;
						flex-direction: column;
						align-items: center;
						gap: 10px 0px;
						margin-top: 15px;

						button {
							display: flex;
							align-items: center;
							width: 103%;
							height: 32px;
							font-size: 14px;
							padding-left: 30px;
							color: #555555;
							font-family: "PingFangSC-Regular";
							// background-image: linear-gradient(to top, #f1f1f1, #e1e2e2, #f1f1f1);
							// box-shadow: 0px 4px 7px 0 rgba(0, 0, 0, 0.15);
							background-color: #f9f8f8;
							border-radius: 3px;
							position: relative;

							img.hotGame {
								position: absolute;
								left: 7px;
								width: 19px;
								margin-right: 5px;
							}

							&:hover {
								background-image: unset;
								background-color: #56b0f0;
								color: #fff;
							}
						}
					}
				}
			}
		}
	}
}

/*右侧用户信息 登录前后*/
.nav-wrapper .user-info {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #fff;
	margin-left: auto;
	width: 100%;

	.login-before {
		display: flex;
		justify-content: flex-end;
		width: 100%;

		.login-button {
			background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
			margin-right: 12px;
			padding: 4px 26px;
			border-radius: 3px;
			color: #fff;
			cursor: pointer;
			border: none;
			font-size: 14px;
			font-family: "PingFangSC-Regular";

			&.play-demo {
				padding: 4px 12px;
				color: #0060a5;
				background-color: #fff;
				background-image: none;
				border: 1px solid #0060a5;
			}
		}
	}

	.login-after {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		align-items: flex-end;
		color: #000;
		position: relative;

		.btn-group {
			display: flex;
			margin-bottom: 9px;

			button {
				font-size: 12px;
				padding: 6px 8px;
				background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
				border: none;
				border-radius: 3px;
				color: #fff;
				cursor: pointer;
				font-family: "PingFangSC-Regular";
				font-weight: normal;
				margin-right: 6px;

				a {
					color: #fff;
				}
			}
		}

		.icon {
			display: flex;
			align-items: center;

			img {
				cursor: pointer;

				&:first-child {
					margin-right: 10px;
				}
			}
		}
	}
}

/*右侧悬浮*/
.float-right {
	position: fixed;
	right: 3px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 999;
}

.float-right li {
	position: relative;
	margin-bottom: 3px;
	width: 50px;
	height: 50px;
}

.float-right li a {
	position: absolute;
	top: 0;
	left: auto;
	right: 0;
	display: flex;
	width: 50px;
	height: 50px;
	border-radius: 5px;
	background: #fff;
	box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.3);
	color: #666;
	overflow: hidden;
	transition: 0.2s;
}

.float-right li a > div {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50px;
	height: 100%;
	background: #fff;
}

.float-right li a .right-text {
	width: 76px;
	color: #1483d1;
	font-size: 13px;
	line-height: 50px;
	text-align: center;
	right: 1px;
	transition: 0.2s;
	border-radius: 6px;
	box-shadow: 0px 4px 7px 0 rgba(0, 0, 0, 0.25);
	border: solid 2px #edf0fa;
	background-image: linear-gradient(to top, #edf0fa, #fff);
}

.float-right li a .right-icon {
	position: absolute;
	top: 0;
	right: 0;
	z-index: 1;
	border-radius: 0 6px 6px 0;
	border: solid 2px #edf0fa;
	background-image: linear-gradient(to top, #edf0fa, #fff);
}

.float-right li a .right-icon img {
	max-width: 100%;
}

.float-right li a:hover {
	width: 122px;
}

.float-right li a:hover .right-icon {
	border-left: none;
	padding-left: 2px;
}

/*管理中心hover后出现的popover*/
.custom-popover {
	.login-time {
		font-size: 12px;
		color: #555;
		text-align: center;

		span {
			color: #6455fe;
		}
	}

	.divider {
		width: 100%;
		height: 1px;
		margin: 10px 0;
		opacity: 0.08;
		background-image: linear-gradient(to top, #000);
	}

	.info-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.username {
			display: flex;
			align-items: center;
			font-size: 13px;
			color: #555;

			&__label {
				width: 48px;
				height: 28px;
				line-height: 28px;
				text-align: center;
				box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03);
				background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa);
				cursor: default;
			}

			&__divider {
				width: 1px;
				height: 28px;
				opacity: 0.12;
				background-image: linear-gradient(to top, transparent 10%, #000 50%, transparent 90%);
			}

			&__value {
				width: 220px;
				height: 28px;
				display: flex;
				align-items: center;
				padding-left: 20px;
				box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03);
				background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa);
				cursor: default;
			}
		}

		.logout {
			display: flex;
			align-items: center;
			padding: 8px 13px 8px 14px;
			border-radius: 6px;
			border: solid 1px #bbb;
			font-size: 13px;
			color: #555;
			cursor: pointer;

			&:hover {
				opacity: 0.6;
			}

			img {
				width: 16px;
				height: 16px;
				margin-right: 5px;
			}
		}
	}

	.menu-wrap {
		display: flex;
		padding: 0 10px;
		margin-top: 22px;
		justify-content: space-between;

		.menu-item {
			.title {
				font-size: 14px;
				color: #555;
				margin-bottom: 17px;
			}

			.subtitle {
				font-size: 12px;
				color: #888;
				cursor: pointer;

				&:hover {
					color: #6455fe;
				}

				&:not(:last-child) {
					margin-bottom: 15px;
				}
			}
		}
	}
}

.login-container {
	background-color: #e5e9f8;
	height: 50px;
	display: flex;
	align-items: center;

	.wrapper {
		width: 100%;
		max-width: 1160px;
		display: flex;
		margin: 0 auto;
		align-items: center;
		justify-content: space-between;

		.help-center {
			width: 100px;
			display: flex;
			align-items: center;

			a {
				color: #555;
				align-items: center;
				display: flex;
				align-items: center;

				img {
					margin-right: 3px;
				}
			}
		}
	}

	/*右侧用户信息 登录前后*/
	.user-info {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #fff;
		width: 100%;

		.login-before {
			display: flex;
			justify-content: flex-end;
			width: 100%;

			.login-button {
				background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);

				margin-right: 12px;
				padding: 4px 26px;
				border-radius: 3px;
				color: #fff;
				cursor: pointer;
				border: none;
				font-size: 14px;
				font-family: "PingFangSC-Regular";

				&:hover {
					background-image: linear-gradient(to top, #218de1, #107dc9, #218de1);
				}

				&.play-demo {
					padding: 4px 12px;
					color: #6455fe;
					background-color: transparent;
					background-image: none;
					border: 1px solid #746eff;
				}
			}
		}

		.login-after {
			display: flex;
			width: 100%;
			height: 100%;
			align-items: center;
			justify-content: flex-end;
			color: #000;
			position: relative;

			.btn-group {
				display: flex;

				button {
					font-size: 12px;
					padding: 5.5px 8px;
					background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);

					border: none;
					border-radius: 3px;
					color: #fff;
					cursor: pointer;
					font-family: "PingFangSC-Regular";
					font-weight: normal;
					margin-right: 10px;
					white-space: nowrap;

					a {
						color: #fff;
					}
				}

				display: flex;
				align-items: center;

				.account-info {
					margin-right: 10px;
				}

				.account-info,
				.balance-info {
					display: flex;

					span {
						display: inline-block;
						font-family: "PingFangSC-Regular";
						color: #555;
						background-size: cover;
						height: 28px;
						line-height: 28px;
						text-align: center;
					}

					span.label {
						min-width: 54px;
						font-size: 13px;
						// background-image: url("~@/static/img/head/label-bg.png");
						display: flex;
						align-items: center;
						border: solid 1px #f2f4fc;
						border-right: 0px solid #f2f4fc;
						background-color: #f2f4fc;

						img {
							width: 16px;
							margin: 0 4px;
						}
					}

					span.content {
						width: 120px;
						font-size: 14px;
						// background-image: url("~@/static/img/head/content-bg.png");
						// border: solid 1px #dedede;
						background-color: #fff;
					}
				}
			}

			.icon {
				display: flex;
				align-items: center;
				margin-left: 10px;
				margin-right: 15px;

				img {
					cursor: pointer;
					margin-right: 10px;
				}
			}
		}
	}
}

/*登录弹窗*/
.login-dialog-enter-active,
.login-dialog-leave-active {
	transition: all 0.3s;
}

.login-dialog-enter,
.login-dialog-leave-to {
	opacity: 0;
	top: -30px;
}
</style>

<style>
.el-button--primary.is-plain::before {
	content: "取消";
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 97%;
	height: 94%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	font-size: 15px;
	color: #6455fe;
	border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue